export default {"src":"/_next/static/media/0xCa3F508B8e4Dd382eE878A314789373D80A5190A.36546af4.svg","height":699,"width":699,"blurWidth":0,"blurHeight":0};